import { observer } from "mobx-react-lite";
import { FC } from "react";
import styled from "@emotion/styled";
import { MDSText, MDSTextVariant, MDSTextWeight } from "@/mds";
import { AppCalloutBannerFormattedPrimaryLabel } from "@/components/banners/app-callout-banner/app-callout-banner-formatted-primary-label";

interface AppCalloutBannerPrimaryLabelProps {
  label: string;
  emphasizedPrefix?: string | null;
}

export const AppCalloutBannerPrimaryLabel: FC<AppCalloutBannerPrimaryLabelProps> = observer(
  ({ label, emphasizedPrefix }) => {
    if (!label) return null;

    return (
      <PrimaryLabelText
        variant={MDSTextVariant.TextM}
        weight={emphasizedPrefix ? MDSTextWeight.Regular : MDSTextWeight.SemiBold}
      >
        <AppCalloutBannerFormattedPrimaryLabel label={label} emphasizedPrefix={emphasizedPrefix} />
      </PrimaryLabelText>
    );
  }
);

const PrimaryLabelText = styled(MDSText)({
  marginBottom: "4px",
});
